import type { PromotePageData } from '../../types';
import type { PromotePageMainDataQuery } from '../getPromotePageMainData.graphql';

export function normalizePetition(
	petition: NonNullable<PromotePageMainDataQuery['petition']>,
): PromotePageData['petition'] {
	const { tagsConnection, ...rest } = petition;
	return {
		...rest,
		categoryTags: tagsConnection?.nodes.map((tag) => tag.name) || [],
	};
}
